import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loading-data-spinner',
  templateUrl: './loading-data-spinner.component.html',
  styleUrls: ['./loading-data-spinner.component.css']
})
export class LoadingDataSpinnerComponent {

  constructor() { }

}
